var _excluded = ["onAddressSelected"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Modal as DesignSystemModal } from '@domain-group/fe-co-allhomes-design-system';
import { AddressSelectAutocomplete } from '@domain-group/fe-co-allhomes-autocomplete';
import * as styles from './follow-another-property.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var FollowAnotherProperty = _ref => {
  var onAddressSelected = _ref.onAddressSelected,
    modalProps = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX(DesignSystemModal, _extends({
    title: "Add another property",
    fitContent: true,
    allowOverflow: true,
    appearance: {
      desktop: 'floating',
      tablet: 'floating',
      mobile: 'fullscreen'
    }
  }, modalProps), ___EmotionJSX("div", {
    css: styles.modalBody
  }, ___EmotionJSX("p", null, "Add another property, and track how much it's worth to keep up to date with local market activity in the area."), ___EmotionJSX(AddressSelectAutocomplete, {
    placeholder: "Type your address and get started",
    buttonText: "Search",
    size: "large",
    onSelectionChange: result => result && onAddressSelected(result.id)
  })));
};
export default FollowAnotherProperty;